// extracted by mini-css-extract-plugin
export default {"link":"ExternalLink_link__OmZrL","icon":"ExternalLink_icon__5WFOp","underlined":"ExternalLink_underlined__GzG8L"};